import axios from 'axios'

const baseUrl = process.env.VUE_APP_API_URL

const $http = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  timeout: 60000,
})

export const buildVersion = () =>
  process.env.VUE_APP_VERSION

const cache = new Map()

setInterval(() => {
  if (cache.size > 100) {
    cache.clear()
  }
}, 600000)

export const invokeHttp = (url, data, config) => {
  const cfg = { ...config }
  if (!cfg.headers) {
    cfg.headers = {}
  }

  const cacheKey = `${url}::${JSON.stringify(data)}`
  const cacheItem = cache.get(cacheKey)
  if (cacheItem) {
    cfg.headers['If-None-Match'] = cacheItem.etag
  }

  return $http.post(url, data, cfg)
    .then((resp) => {
      const etag = resp.headers.etag
      if (etag) {
        cache.set(cacheKey, {
          etag,
          data: JSON.parse(JSON.stringify(resp.data)),
        })
      }
      return resp.data
    }, (err) => {
      if (err.response.status === 304 && cacheItem) {
        return JSON.parse(JSON.stringify(cacheItem.data))
      }
      throw err
    })
}

export const invokeSse = (url) =>
  new EventSource(baseUrl + url, {
    withCredentials: true,
  })
